define('reports',['controller'], function(controller) {

    controller.on('reports/add', function() {
        $('#form-category-input').select2({
            minimumResultsForSearch: -1,
            width: '100%'
        });
    });
});
